import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ExperienceType } from '../../types/vmdata'
import { Experience } from '../../types/expType'

const initialState = Experience.VMGEN as ExperienceType

const name = createSlice({
  name: 'vm-bo/exp-type',
  initialState,
  reducers: {
    setExperienceType: (_, action: PayloadAction<ExperienceType>) => {
      return action.payload || ''
    },
  },
})

export const { setExperienceType } = name.actions
export default name.reducer
